// extracted by mini-css-extract-plugin
export default {"contributorUsername":"_3SfjWSYz","commits":"_29pBpx3X","thumbnail":"Fig7v5jp"};